import axios from 'axios'

const apiClient = axios.create({ withCredentials: true})

export default {
  auth: {
    checkUser (payload) {
      return apiClient.post('/checkUserExistByEmail', payload)
    },
    fortgetPassword (payload) {
      return apiClient.post('/forgotPasswordByEmail', payload)
    },
    resetPassword (payload) {
      return apiClient.post('/resetPasswordByEmail', payload)
    }
  }
}
